<template>
  <v-card>
    <v-card-title class="pa-0">
      <v-tabs style="border-top-right-radius: 0.5rem; border-top-left-radius: 0.5rem" grow background-color="primary"
        active-class="subtitle-1 font-weight-bold" center-active v-model="activeTab">
        <v-tab class="tabText tab-with-diff" @click.prevent="setGetFavoritas(false, false, false, 0)" :key="0">
          Colaborações recebidas
          <span class="tab-count" :class="{ 'tab-count--hidden': !(copyColaboracoesRecebidas && copyColaboracoesRecebidas.totalItems > 0) }">
            {{ copyColaboracoesRecebidas && copyColaboracoesRecebidas.totalItems > 0 ? copyColaboracoesRecebidas.totalItems : '0' }}
          </span>
          <span
            v-if="diff > 0 && $store.state.producoes.automaticUpdateOfColabs !== 1"
            class="tab-diff-indicator"
          >
            +{{ diff }}
          </span>
        </v-tab>
        <v-tab class="tabText" @click.prevent="setGetFavoritas(true, false, false, 0)" :key="1">
          Favoritas
          <span class="tab-count" :class="{ 'tab-count--hidden': !(data && data.colaboracoes_favoritas && data.colaboracoes_favoritas.totalItems > 0) }">
            {{ data && data.colaboracoes_favoritas && data.colaboracoes_favoritas.totalItems > 0 ? data.colaboracoes_favoritas.totalItems : '0' }}
          </span>
        </v-tab>
        <v-tab class="tabText" @click.prevent="setGetFavoritas(false, true, false, 0)" :key="2">
          Exibidas
          <span class="tab-count" :class="{ 'tab-count--hidden': !(data && data.colaboracoes_exibidas && data.colaboracoes_exibidas.totalItems > 0) }">
            {{ data && data.colaboracoes_exibidas && data.colaboracoes_exibidas.totalItems > 0 ? data.colaboracoes_exibidas.totalItems : '0' }}
          </span>
        </v-tab>
        <v-tab class="tabText" @click.prevent="setGetFavoritas(false, false, true, model_cod_pasta)" :key="3">
          Pastas
          <span class="tab-count" :class="{ 'tab-count--hidden': !(data && data.colaboracoes_em_pasta && data.colaboracoes_em_pasta.totalItems > 0) }">
            {{ data && data.colaboracoes_em_pasta && data.colaboracoes_em_pasta.totalItems > 0 ? data.colaboracoes_em_pasta.totalItems : '0' }}
          </span>
        </v-tab>
      </v-tabs>

      <v-container class="colab-toolbar-container" fluid>
        <div class="colab-toolbar">
          <v-text-field
            prepend-inner-icon="mdi-magnify"
            solo flat dense hide-details
            placeholder=""
            background-color="surface_tertiary"
            v-model="filtro_texto"
            @input="onChange"
            aria-label="Buscar"
            class="colab-search"
          />

          <v-select
            v-if="activeTab === 3"
            v-model="model_cod_pasta"
            :items="pastas"
            item-value="cod_pasta"
            item-text="dsc_nome_pasta"
            placeholder="Pasta"
            solo flat dense hide-details
            background-color="surface_tertiary"
            @change="setCodPasta(model_cod_pasta)"
            class="colab-dropdown"
          />

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <button class="colab-toolbar-btn" aria-label="Filtrar" v-bind="attrs" v-on="on" @click.prevent="showModalFiltros">
                <v-icon size="18">mdi-filter-variant</v-icon>
                <div v-if="active_filtro" class="colab-filter-dot" />
              </button>
            </template>
            <span>Filtrar</span>
          </v-tooltip>

          <ColaboracaoAprovadaDropDown :fetchColaboracoesAprovadas="fetchColaboracoesAprovadas" />
        </div>


        <div v-if="activeTab === 0 && copyColaboracoesRecebidas" class="columnWrapper">
          <div v-for="item, idx in copyColaboracoesRecebidas.items" :key="item.id_colaboracao"
            class="card-item-wrapper drag-source" :class="{ 'drag-source--dragging': draggingId === item.id_colaboracao }" draggable @dragstart="startDrag($event, item)" @dragend="endDrag">
            <CardColaboracaoAprovada :key="item.url_midia_colaboracao" :item="item" :index="idx" :getColaboracoesAprovadas="getColaboracoesAprovadas"
              :getColaboracoesModeradas="getColaboracoesModeradas" :currentPage="copyColaboracoesRecebidas.currentPage"
              :num_coluna_telao="num_coluna_telao" :cod_pasta="cod_pasta" />
          </div>
        </div>


        <div v-if="activeTab === 1 && data.colaboracoes_favoritas" class="columnWrapper">
          <div v-for="item, idx in data.colaboracoes_favoritas.items" :key="item.id_colaboracao"
            class="card-item-wrapper drag-source" :class="{ 'drag-source--dragging': draggingId === item.id_colaboracao }" draggable @dragstart="startDrag($event, item)" @dragend="endDrag">
            <CardColaboracaoAprovada :key="item.url_midia_colaboracao" :item="item" :index="idx" :getColaboracoesAprovadas="getColaboracoesAprovadas"
              :getColaboracoesModeradas="getColaboracoesModeradas" :currentPage="data.colaboracoes_favoritas.currentPage"
              :num_coluna_telao="num_coluna_telao" :cod_pasta="cod_pasta" />
          </div>
        </div>

        <div v-if="activeTab === 2 && data.colaboracoes_exibidas" class="columnWrapper">
          <div v-for="item, idx in data.colaboracoes_exibidas.items" :key="item.id_colaboracao"
            class="card-item-wrapper drag-source" :class="{ 'drag-source--dragging': draggingId === item.id_colaboracao }" draggable @dragstart="startDrag($event, item)" @dragend="endDrag">
            <CardColaboracaoAprovada :key="item.url_midia_colaboracao" :item="item" :index="idx" :getColaboracoesAprovadas="getColaboracoesAprovadas"
              :getColaboracoesModeradas="getColaboracoesModeradas" :currentPage="data.colaboracoes_exibidas.currentPage"
              :num_coluna_telao="num_coluna_telao" :cod_pasta="cod_pasta" />
          </div>
        </div>

        <div v-if="activeTab === 3 && data.colaboracoes_em_pasta" class="columnWrapper">
          <div v-for="item, idx in data.colaboracoes_em_pasta.items" :key="item.id_colaboracao"
            class="card-item-wrapper drag-source" :class="{ 'drag-source--dragging': draggingId === item.id_colaboracao }" draggable @dragstart="startDrag($event, item)" @dragend="endDrag">
            <CardColaboracaoAprovada :key="item.url_midia_colaboracao" :item="item" :index="idx" :getColaboracoesAprovadas="getColaboracoesAprovadas"
              :getColaboracoesModeradas="getColaboracoesModeradas" :currentPage="data.colaboracoes_em_pasta.currentPage"
              :num_coluna_telao="num_coluna_telao" :cod_pasta="cod_pasta" />
          </div>
        </div>

      </v-container>
    </v-card-title>

    <ModalFiltrar :dialog="isModalFiltrosVisible" @close="closeModalFiltros" :cod_producao="cod_producao"
      :cod_pasta="cod_pasta" />
  </v-card>
</template>

<script>

import ModalFiltrar from "@/components/Modal/ModalFiltrar.vue";
// import ModalImagem from "@/components/Modal/ModalImagem.vue";
// import ModalEditarColaboracao from "../Modal/Colaboracao/ModalEditarColaboracao.vue";
// import ModalExcluirColaboracao from "../Modal/Colaboracao/ModalExcluirColaboracao.vue";
import CardColaboracaoAprovada from "../Cards/CardColaboracaoAprovada.vue";
import { mapActions, mapGetters } from "vuex";
import { capitalizeString } from "@/utils/capitalizeString";
import ColaboracaoAprovadaDropDown from "./ColaboracaoAprovadaDropDown.vue";
import { dragSourceMixin } from "@/mixins/dragAndDrop";
export default {
  mixins: [dragSourceMixin],
  components: {
    ModalFiltrar,
    // ModalImagem,
    // ModalEditarColaboracao,
    // ModalExcluirColaboracao,
    CardColaboracaoAprovada,
    ColaboracaoAprovadaDropDown
  },
  props: {
    data: Object,
    showModal: Function,
    closeModal: Function,
    cod_producao: Number,
    currentAprovadasPage: Number,
    num_coluna_telao: Number,
    changeFlags: Function,
    diff: Number,
  },
  data() {
    return {
      dragIdField: 'id_colaboracao',
      imagem_url: "",
      isModalFiltrosVisible: false,
      filtro_texto: "",
      flg_favorita: "",
      isModalImagemAprovadasVisible: false,
      midia_url_aprovadas: "",
      media_type: "",
      debounce: null,
      loading: false,
      activeTab: 0,
      flg_exibida: false,
      model_cod_pasta: 0,
    };
  },
  beforeMount() {
    this.filtro_texto = localStorage.getItem("@socialcam/filtro_texto") || "";
    this.flg_favorita =
      JSON.parse(localStorage.getItem("@socialcam/flg_favorita")) || false;
    this.flg_exibida = JSON.parse(localStorage.getItem("@socialcam/flg_exibida")) || false
    this.model_cod_pasta = JSON.parse(localStorage.getItem("@socialcam/cod_pasta") || 0)
    this.activeTab = this.isPastaAtiva ? 3 : this.flg_exibida ? 2 : this.flg_favorita ? 1 : 0
  },
  computed: {
    breakpoint() {
      return this.$vuetify.breakpoint.name;
    },
    filtros() {
      return localStorage.getItem("@socialcam/filtros") || "";
    },
    ...mapGetters({
      filtros_redes_sociais: "colaboracoes_aprovadas/filtros_redes_sociais",
      active_filtro: "colaboracoes_aprovadas/active_filtro",
      copyColaboracoesRecebidas: "colaboracoes_aprovadas/getCopyColaboracoesRecebidas",
      pastas: 'pastas/getterPastas',
      cod_pasta: 'pastas/getterCodPasta',
      isPastaAtiva: 'pastas/getterIsPastaAtiva',
    }),
  },
  filters: {
    formatedDate(date) {
      return new Date(date).toLocaleDateString();
    },
    formatedHour(date) {
      return new Date(date)
        .toLocaleTimeString()
        .split(":")
        .slice(0, 2)
        .join(":");
    },
  },
  methods: {
    ...mapActions({
      getColaboracoesAprovadas:
        "colaboracoes_aprovadas/getColaboracoesAprovadas",
      getColaboracoesModeradas:
        "colaboracoes_moderadas/getColaboracoesModeradas",
      setCopyColaboracoesRecebidas: "colaboracoes_aprovadas/setCopyColaboracoesRecebidas",
      getFiltrosLive: "colaboracoes_aprovadas/getFiltrosLive",
    }),
    async showModalImagem(midia_url_aprovadas, media_type) {
      this.isModalImagemAprovadasVisible = true;
      this.midia_url_aprovadas = midia_url_aprovadas;
      this.media_type = media_type;
    },
    async closeModalImagem() {
      this.isModalImagemAprovadasVisible = false;
    },
    capitalize(string) {
      return capitalizeString(string);
    },
    async setCodPasta(cod_pasta) {
      this.$store.commit('pastas/setCodPasta', cod_pasta)
      localStorage.setItem("@socialcam/cod_pasta", cod_pasta)
      await this.getColaboracoesAprovadas({
        page: this.currentAprovadasPage,
        size: 5,
        cod_producao: this.cod_producao,
        flg_favorita: this.flg_favorita,
        flg_exibida: this.flg_exibida,
        cod_pasta: this.cod_pasta
      });

    },
    async setGetFavoritas(flg_favorita, flg_exibida, pasta, cod_pasta) {
      try {
        this.loading = true;
        this.changeFlags({ flg_exibida, flg_favorita })
        this.flg_favorita = flg_favorita;
        this.flg_exibida = flg_exibida;
        this.$store.commit('pastas/setCodPasta', cod_pasta)
        this.$store.commit('pastas/setIsPastaAtiva', pasta)
        localStorage.setItem("@socialcam/flg_favorita", flg_favorita);
        localStorage.setItem("@socialcam/flg_exibida", flg_exibida);
        localStorage.setItem("@socialcam/isPastaAtiva", pasta)
        localStorage.setItem("@socialcam/cod_pasta", cod_pasta)

        const loadPage = this.flg_favorita ? 1 : this.currentAprovadasPage;
        await this.getColaboracoesAprovadas({
          page: loadPage,
          size: 5,
          cod_producao: this.cod_producao,
          flg_favorita,
          flg_exibida,
          cod_pasta: this.cod_pasta
        });

        if (!flg_favorita && !flg_exibida) {
          this.setCopyColaboracoesRecebidas(this.$store.state.colaboracoes_aprovadas.colaboracoes.colaboracoes_recebidas);
        }
        this.$emit("changeFavorita", flg_favorita);
      } catch (error) {
        console.error(error);
        return this.$toast.error("Não foi possível buscar as favoritas");
      } finally {
        this.loading = false
      }
    },
    async showModalFiltros() {
      try {
        this.isModalFiltrosVisible = true;
      } catch (error) {
        return this.$toast.error("Não foi possível abrir modal de filtros");
      }
    },
    closeModalFiltros() {
      this.isModalFiltrosVisible = false;
    },
    onChange(e) {
      localStorage.setItem("@socialcam/filtro_texto", e);

      clearTimeout(this.debounce);

      this.debounce = setTimeout(async () => {
        await this.getColaboracoesAprovadas({
          page: 1,
          size: 5,
          cod_producao: this.cod_producao,
          flg_favorita: this.flg_favorita,
          filtros: this.filtros,
          filtro_texto: this.filtro_texto,
          flg_exibida: this.flg_exibida,
          cod_pasta: this.cod_pasta
        });
        this.setCopyColaboracoesRecebidas(this.$store.state.colaboracoes_aprovadas.colaboracoes.colaboracoes_recebidas);

      }, 1500);


    },
    async fetchColaboracoesAprovadas() {
      const colaboracoes = this.$store.state.colaboracoes_aprovadas.colaboracoes;
      // activeTab routes which dataset's currentPage to read. The Pastas tab
      // (activeTab === 3) was previously falling through to colaboracoes_recebidas,
      // which made its pagination behave like the Recebidas tab.
      const page = this.activeTab === 3
        ? colaboracoes.colaboracoes_em_pasta?.currentPage
        : this.flg_exibida
          ? colaboracoes.colaboracoes_exibidas?.currentPage
          : this.flg_favorita
            ? colaboracoes.colaboracoes_favoritas?.currentPage
            : colaboracoes.colaboracoes_recebidas?.currentPage;


      await this.getColaboracoesAprovadas({
        page,
        size: 5,
        cod_producao: this.cod_producao,
        flg_favorita: this.flg_favorita,
        filtro_texto: this.filtro_texto,
        flg_exibida: this.flg_exibida,
        cod_pasta: this.cod_pasta
      });
    }
  },
  watch: {
    "$store.state.producoes.selectedProducao": function () {
      this.setCopyColaboracoesRecebidas(this.$store.state.colaboracoes_aprovadas.colaboracoes.colaboracoes_recebidas);
    },
  }
};
</script>

<style lang="scss" scoped>
$badge-dot-height: 0px !important;
$badge-dot-width: 0px !important;

.v-tab {
  text-transform: none !important;
  color: #171717 !important;
}

// "Colaborações recebidas" tab carries a diff indicator (+N new colabs since
// last refresh) when auto-update is off. The indicator floats over the tab's
// top-right corner. The tab itself is position: relative so the indicator
// anchors to it without needing a wrapper span (which broke color cascade).
.tab-with-diff {
  position: relative;
}

.tab-diff-indicator {
  position: absolute;
  top: 4px;
  right: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 22px;
  height: 18px;
  padding: 0 6px;
  border-radius: 9999px;
  background: var(--v-error-base);
  color: #fff;
  font-size: 0.65rem;
  font-weight: var(--sc-weight-bold);
  line-height: 1;
  letter-spacing: 0;
  text-transform: none;
  pointer-events: none;
}

.v-text-field__details {
  display: none !important;
}

.card-item-wrapper {
  margin-bottom: 8px;
}
</style>
